import { Action } from '@ngrx/store';
import { NetOpenPosition } from '../../model/NetOpenPosition';

export enum NetOpenPositionActionTypes {
  InitNetOpenPositions = 'InitNetOpenPositions',
  InitNetOpenPositionPairData = 'InitNetOpenPositionPairData',
  AddNetOpenPosition = 'AddNetOpenPosition',
  RemoveNetOpenPosition = 'RemoveNetOpenPosition',
  UpdateNetOpenPosition = 'UpdateNetOpenPosition',
}

export class InitNetOpenPositions implements Action {
  readonly type = NetOpenPositionActionTypes.InitNetOpenPositions;

  constructor(public payload: any) {
  }
}

export class InitNetOpenPositionPairData implements Action {
  readonly type = NetOpenPositionActionTypes.InitNetOpenPositionPairData;

  constructor(public payload: any) {
  }
}

export class AddNetOpenPosition implements Action {
  readonly type = NetOpenPositionActionTypes.AddNetOpenPosition;

  constructor(public payload: NetOpenPosition) {
  }
}

export class RemoveNetOpenPosition implements Action {
  readonly type = NetOpenPositionActionTypes.RemoveNetOpenPosition;

  constructor(public payload: string) {
  }
}

export class UpdateNetOpenPosition implements Action {
  readonly type = NetOpenPositionActionTypes.UpdateNetOpenPosition;

  constructor(public payload: NetOpenPosition) {
  }
}

export type NetOpenPositionActions =
  InitNetOpenPositions |
  InitNetOpenPositionPairData |
  AddNetOpenPosition |
  RemoveNetOpenPosition |
  UpdateNetOpenPosition;
